<template>
  <div>
    <!--城际订单详情-->
    <IntercityInfo ref="intercityInfo" />
    <!--摆渡、接送机订单详情-->
    <ferry-order ref="ferryOrderInfo" />
    <!--小件快运详情-->
    <express-detail ref="expressDetail" />
    <!--班次详情-->
    <RunningplanView ref="runningplanView" :needHide="needHide" />
    <!--车辆详情-->
    <VehicleDetail ref="vehicleDetail" />
    <!--地图显示位置 location-->
    <yd-map-location v-model="location.show" :markerInfo="location.markerInfo" />
    <!--绑定供应商详情-->
    <boundmerchant-detal ref="merchantDetal" />
  </div>
</template>

<script>
  import IntercityInfo from '@/views/order/intercity/intercity-info.vue'
  import RunningplanView from '@/views/product/transport/runningplan/runningplan-view.vue'
  import VehicleDetail from '@/views/vehicle/components/vehicle-detail.vue'
  import FerryOrder from '@/views/order/ferry/order-info.vue'
  import BoundmerchantDetal from '@/views/product/transport/bound/boundmerchant-detal.vue'
  import ExpressDetail from '@/views/order/express/components/detail.vue'

  export default {
    components: {
      IntercityInfo,
      RunningplanView,
      VehicleDetail,
      FerryOrder,
      BoundmerchantDetal,
      ExpressDetail
    },
    data() {
      return {
        type: '',
        location: {
          show: false,
          markerInfo: {}
        },
        needHide: true
      }
    },
    methods: {
      init(params) {
        let _params = params || {}
        const { type, id, needHide = true } = _params
        console.log(needHide)
        this.type = type
        this.needHide = needHide
        switch (type) {
          case 'location':
            this.openMapLocation(params)
            break
          case 'vehicleDetail':
            _params = id
            this.openDetail(_params)
            break
          case 'merchantDetal':
            this.openBoundmerchantDetal(_params)
            break
          case 'expressDetail':
            this.openExpressDetail(_params)
            break
          default:
            this.openDetail(_params)
        }
      },
      openDetail(params) {
        this.$nextTick(() => {
          this.$refs[this.type] && this.$refs[this.type].init(params)
        })
      },
      // 查看地理位置
      openMapLocation(params) {
        const _params = params || {}
        this.location.markerInfo = { ..._params }
        this.location.show = true
      },
      // 打开绑定供应商详情
      openBoundmerchantDetal(params) {
        this.$nextTick(() => {
          this.$refs[this.type] && this.$refs[this.type].edit(params)
        })
      },
      // 查看小件快运订单详情
      openExpressDetail(params) {
        this.$nextTick(() => {
          this.$refs[this.type] && this.$refs[this.type].getDetail(params)
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
